import { slugs } from '@/constants/slugs'
import { DEFAULT_FILTER_MIN_CHARS, DEFAULT_STORIES_TO_SHOW, ProjectTheme, StorySort } from './types'

export const riotAndTheDanceSeries: ProjectTheme = {
  slug: slugs.riotAndTheDanceSeries,
  name: 'The Riot and the Dance',
  logo: 'v1658210096/angel-studios/themes/riot/logo_subscription.webp',
  lightTheme: {
    themeName: 'light',
    colors: {
      primary: '#325B09',
      onPrimary: '#000000',
      secondary: '#9A822C',
      onSecondary: '#000000',
      tertiary: '#3DE2B6',
      onTertiary: '#000000',
    },
  },
  darkTheme: {
    themeName: 'dark',
    colors: {
      primary: '#3DE2B6',
      onPrimary: '#000000',
      secondary: '#9A822C',
      onSecondary: '#000000',
      tertiary: '#325B09',
      onTertiary: '#000000',
    },
  },
  payItForward: {
    logo: {
      cloudinaryPath: 'v1651006086/angel-studios/themes/riot/logo_pif',
      height: 274,
      width: 300,
    },
    logoOverlayClassName: 'w-[15%]',
  },
  stories: {
    filterMinChars: DEFAULT_FILTER_MIN_CHARS,
    sort: StorySort.NEWEST,
    numStories: DEFAULT_STORIES_TO_SHOW,
    allowShareStory: false,
  },
  merch: {
    storeUrl: 'https://angel-studios-inc.myshopify.com/api/2022-07/graphql.json',
    accessToken: 'ba113b3c3998ae023db05e42a85a6ac8',
    handle: 'riot-the-dance',
  },
}
